export default __webpack_public_path__ + "static/media/gallery-wip-pommel_05.c7f8ca1c.jpg";